import { render, staticRenderFns } from "./UserSettingsModal.vue?vue&type=template&id=2a3dc81f&scoped=true&"
import script from "./UserSettingsModal.vue?vue&type=script&lang=ts&"
export * from "./UserSettingsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3dc81f",
  null
  
)

export default component.exports